export default __webpack_public_path__ + "3525935a84cfeec3c194eafde76fa411.svg";